import React from 'react';
import { Outlet } from 'react-router-dom';

interface UserDashboardLayoutProps {
  children?: React.ReactNode;
}

/** Account page content shell - no sidebar; navigation via store header. */
const UserDashboardLayout: React.FC<UserDashboardLayoutProps> = ({ children }) => (
  <div className="min-h-[60vh] bg-gray-50">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      {children || <Outlet />}
    </div>
  </div>
);

export default UserDashboardLayout;